import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";
//----------------------------------------------------

// GET =>  getDaysOfWeek
export const getDaysOfWeek = createAsyncThunk(
    "setting/getDaysOfWeek",
    async (data, thunkAPI) => {
        try {
            const response = await axios.get(URLS.getDaysOfWeekURL);
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);